import { DATA_ATTRIBUTE } from '../../constants/project';


/**
 * The data attribute for the autoplay interval duration.
 *
 * @since 3.5.0
 */
export const INTERVAL_DATA_ATTRIBUTE = `${ DATA_ATTRIBUTE }-interval`;
